import { general } from './general'
import { views } from './views'
import { components } from './components'

export const pl = {
  general,
  views,
  components
}
